import React, { useEffect, useState } from "react";
import ProgressChart from "../components/ProgressChart";
import { AllTicketsCount } from "../constants/const";
import leftArrow from "../assets/icons/left-arrow.svg";
import JackpotIcon from "../assets/images/jackpot-image.svg";
import { useNavigate } from "react-router";
import MainButton from "../components/MainButton";
import BuyTicketIcon from "../assets/icons/buy-ticket-icon.svg";
import { Input, Modal, Progress, Spin, Switch } from "antd";
import TonIcon from "../assets/icons/ton-icon.svg";
import DecrementIcon from "../assets/icons/decrement-icon.svg";
import IncrementIcon from "../assets/icons/increment-icon.svg";
import CompleteModal from "../components/CompleteModal";
import RegularGameIcon from "../assets/images/regular-game-icon.svg";
import StandardGameIcon from "../assets/images/standard-game-icon.svg";
import PremiumGameIcon from "../assets/images/premium-game-icon.svg";
import SearchIcon from "../assets/icons/search-icon.svg";
import TicketIcon from "../assets/icons/ticket-icon.svg";
import TicketDisabledIcon from "../assets/icons/ticket-disabled-icon.svg";
import { useTonConnectUI, useTonAddress, useTonWallet } from "@tonconnect/ui-react";

import { gameCategoryCards } from "../constants/const";
import { buyTicket, getCycleSold, getLevelPriceNano, buyLuckyTicket, waitForSoldIncrease, getTakenTickets } from "../blockchain/lotteryClient";
import JackpotImage from "../assets/images/ton-image.svg";


function JackpotPage() {
    const [soldTicketsCount, setSoldTicketsCount] = useState<number>(0);
    const [selectedTicketId, setSelectedTicketId] = useState<number | null>(null);
    // const [gameName, setGameName] = useState<string>("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [isError, setIsError] = useState(false);
    const [infoModalOpen, setInfoModalOpen] = useState(false);

    const [gameInfo, setGameInfo] = useState({ name: "", icon: "" });
    const [inputValue, setInputValue] = useState(1);

    const [isNotTicket, setIsNotTicket] = useState<boolean>(false);
    const [allTickets, setAllTickets] = useState<any[]>([]);
    const [isChecked, setIsChecked] = useState<boolean>(false);

    const [tonConnectUI] = useTonConnectUI();
    const [ticketPriceNano, setTicketPriceNano] = useState<bigint>(0n);
    const [ticketPrice, setTicketPrice] = useState<number>(0);

    const [totalCountNano, setTotalCountNano] = useState<bigint>(0n);
    const [totalCount, setTotalCount] = useState<number>(0);
    const [level, setLevel] = useState<number>(0);
    const contractLevel = level;
    const [searchValue, setSearchValue] = useState<string>("");
    const [takenSet, setTakenSet] = useState<Set<number>>(new Set());

    const navigate = useNavigate();
    const wallet: any = useTonWallet();
    const userAddress = useTonAddress(false);


    useEffect(() => {
        const gameKey = localStorage.getItem("gameName");

        let lvl = 0;

        switch (gameKey) {
            case "regular-game":
                setGameInfo({ name: "Регулярная игра", icon: RegularGameIcon });
                lvl = 0;
                break;
            case "standard-game":
                setGameInfo({ name: "Стандартная игра", icon: StandardGameIcon });
                lvl = 1;
                break;
            case "premium-game":
                setGameInfo({ name: "Премиум игра", icon: PremiumGameIcon });
                lvl = 2;
                break;
            default:
                return;
        }

        setLevel(lvl);

    }, []);

    useEffect(() => {
        if (level !== null) {
            loadLotteryState(contractLevel, inputValue);
        }
    }, [level]);

    const loadLotteryState = async (lvl: number, inputVal: number) => {
        setLoading(true);

        try {
            const [priceResult, soldResult, takenResult] = await Promise.allSettled([
                getLevelPriceNano(lvl),
                getCycleSold(lvl),
                getTakenTickets(lvl),
            ]);

            if (priceResult.status === "fulfilled") {
                const priceNano = priceResult.value;
                setTicketPriceNano(priceNano);

                const priceTon = Number(priceNano) / 1e9;
                setTicketPrice(priceTon);

                setTotalCountNano(priceNano * BigInt(inputVal));
                setTotalCount(priceTon * inputVal);
            } else {
                setTicketPriceNano(0n);
                setTicketPrice(0);
                setTotalCountNano(0n);
                setTotalCount(0);
            }

            if (soldResult.status === "fulfilled") {
                setSoldTicketsCount(soldResult.value);
            }

            if (takenResult.status === "fulfilled") {
                setTakenSet(new Set(takenResult.value));
            }

            const TOTAL_TICKETS = AllTicketsCount;

            const tickets = Array.from({ length: TOTAL_TICKETS }, (_, i) => ({
                ticket_number: i + 1,
            }));

            setAllTickets(tickets);

        } catch (e) {
            // Keep UI usable even if one of the RPC reads temporarily fails.
        }

        setLoading(false);
    };

    const handleBuyJackpotTicket = async () => {
        if (loading) return;
        if (!tonConnectUI.connected) {
            await tonConnectUI.openModal();
            return;
        }

        const prevSold = soldTicketsCount;

        try {
            setLoading(true);
            setIsModalOpen(false);

            await buyTicket(
                tonConnectUI,
                contractLevel,
                inputValue
            );

            const newSold = await waitForSoldIncrease(contractLevel, prevSold);

            setSoldTicketsCount(newSold);
            const takenIds = await getTakenTickets(contractLevel);
            setTakenSet(new Set(takenIds));
            setIsError(false);
            setInfoModalOpen(true);

        } catch (e) {
            console.error("BUY ERROR:", e);
            setIsError(true);
            setInfoModalOpen(true);
        } finally {
            setLoading(false);
        }
    };

    const handleBuyLuckyTicket = async (ticketId: number) => {
        if (loading) return;
        if (!tonConnectUI.connected) {
            await tonConnectUI.openModal();
            return;
        }

        const prevSold = soldTicketsCount;

        try {
            setLoading(true);

            await buyLuckyTicket(
                tonConnectUI,
                contractLevel,
                ticketId
            );

            const newSold = await waitForSoldIncrease(contractLevel, prevSold);

            setSoldTicketsCount(newSold);
            const takenIds = await getTakenTickets(contractLevel);
            setTakenSet(new Set(takenIds));
            setIsError(false);
            setInfoModalOpen(true);

        } catch (e) {
            console.error("LUCKY BUY ERROR:", e);
            setIsError(true);
            setInfoModalOpen(true);
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => setIsModalOpen(false);

    const handleOpenBuyJackpotModal = async () => {
        if (tonConnectUI.connected) {
            setIsModalOpen(true);
        } else {
            tonConnectUI.openModal().then(() => {
                const interval = setInterval(() => {
                    if (tonConnectUI.connected) {
                        clearInterval(interval);
                        setIsModalOpen(true);
                    }
                }, 500);
            });
        }
    };


    const handleInputValue = (e: any) => {
        const val = Number(e.target.value);
        if (val >= 1 && val <= AllTicketsCount) {
            setInputValue(val);
            setTotalCountNano(ticketPriceNano * BigInt(val));
            setTotalCount(Number(ticketPriceNano * BigInt(val)) / 1e9);

        }
    };

    const handleDecrement = () => {
        if (inputValue > 1) {
            const v = inputValue - 1;
            setInputValue(v);
            const nano = ticketPriceNano * BigInt(v);
            setTotalCountNano(nano);
            setTotalCount(Number(nano) / 1e9);

        }
    };

    const handleIncrement = () => {
        if (inputValue < AllTicketsCount) {
            const v = inputValue + 1;
            setInputValue(v);
            const nano = ticketPriceNano * BigInt(v);
            setTotalCountNano(nano);
            setTotalCount(Number(nano) / 1e9);

        }
    };

    const onSwitchChange = (checked: boolean) => {
        setIsChecked(checked);
    };

    // const handleSearchNumber = (event: any) => {
    //     const number = event.target.value;

    //     if (number >= 1 && number <= 777) {
    //         setIsNotTicket(false);
    //         if (number.length > 0) {
    //             const ticket = allTickets.filter(t => t.ticket_number === number);
    //         }
    //     } else {
    //         setIsNotTicket(true);
    //     }
    // };

    const handleSearchNumber = (e: any) => {
        const v = e.target.value.trim();
        setSearchValue(v);

        if (v === "") {
            setIsNotTicket(false);
            return;
        }

        const num = Number(v);
        setIsNotTicket(!(Number.isInteger(num) && num >= 1 && num <= AllTicketsCount));
    };

    const visibleTicketsBase = isChecked
        ? allTickets.filter(t => !takenSet.has(t.ticket_number))
        : allTickets;

    const visibleTickets = searchValue
        ? visibleTicketsBase.filter(t => t.ticket_number === Number(searchValue))
        : visibleTicketsBase;



    const accessibleTicketsCount = Math.max(AllTicketsCount - takenSet.size, 0);
    const progressPercent = Math.floor((soldTicketsCount / AllTicketsCount) * 100);


    return (
        <>
            {loading ? (
                <Spin fullscreen={true} size="large" />
            ) : (


                <div className="game-page">
                    <div className="game-page_title">
                        <img
                            className="game-page_title_left-arrow"
                            src={leftArrow}
                            alt="icon"
                            width={32}
                            height={32}
                            onClick={() => navigate("/games")}
                        />
                        <span>{gameInfo.name}</span>
                    </div>

                    <div className="game-page_game-info">
                        <div className="game-page_game-info__price">
                            Стоимость билета: {ticketPrice !== null ? `${ticketPrice} TON` : "Загрузка..."}
                        </div>

                        <img src={gameInfo.icon} alt="icon" height={300} />
                    </div>

                    <div className="jackpot-header_game-info">
                        <div className="jackpot-header_game-info__title">
                            Твой счастливый билет здесь! Пожалуйста, убедитесь, что на вашем кошельке достаточно средств для оплаты билета и газа. После покупки билет появится в разделе «Профиль».чем больше билетов приобретаете,тем больше шанс выиграть Джекпот
                        </div>
                    </div>

                    <MainButton
                        icon={BuyTicketIcon}
                        text={"Купить билет за"}
                        price={totalCount}
                        func={handleOpenBuyJackpotModal}
                        disabled={loading}
                    />

                    <div className="jackpot-card" >
                        <div className="jackpot-card_header">
                            <div className="jackpot-card_header__info">
                                <span className="jackpot-card_header__info___title">
                                    Джекпот
                                </span>
                                <span className="jackpot-card_header__info___subtitle">
                                    Доступные билеты:
                                </span>
                                <div className="jackpot-card_header__info___ticket-count">
                                    <span className="jackpot-card_header__info___ticket-count____accessible-count">
                                        {accessibleTicketsCount}
                                    </span>
                                    <span className="jackpot-card_header__info___ticket-count____total-count">
                                        / {AllTicketsCount}
                                    </span>
                                </div>
                                <div className="charts">
                                    <Progress
                                        percent={progressPercent}
                                        strokeColor="#FFD700"
                                        percentPosition={{ align: "end", type: "inner" }}
                                        size={["100%", 16]}
                                    />

                                </div>
                            </div>
                            <img src={JackpotImage} alt="icon" />
                        </div>
                    </div>






                    <Modal
                        title="Джекпот"
                        open={isModalOpen}
                        onCancel={handleCancel}
                        footer={null}
                        rootClassName="buy-ticket-modal"
                    >
                        <div className="buy-ticket-modal-content">
                            <div className="buy-ticket-modal-content_title">{gameInfo.name}</div>
                            <img src={TonIcon} alt="icon" />
                            <div className="buy-ticket-modal-content_price"> {ticketPrice} TON</div>
                        </div>

                        <div className="buy-ticket-block" style={{ background: "#272D41", marginTop: "26px" }}>
                            <div className="buy-ticket-block_header">
                                <div className="buy-ticket-block_header__title">Количество билетов</div>
                                <div className="buy-ticket-block_header__subtitle">
                                    Выберите количество билетов.
                                </div>
                            </div>

                            <div className="ticket-count-input" style={{ background: "#131620" }}>
                                <img src={DecrementIcon} alt="icon" onClick={handleDecrement} />

                                <input
                                    type="text"
                                    className="ticket-count-input_count"
                                    style={{ background: "#131620" }}
                                    value={inputValue}
                                    onChange={handleInputValue}
                                />

                                <img src={IncrementIcon} alt="icon" onClick={handleIncrement} />
                            </div>

                            <div className="buy-ticket-block_btn">
                                <MainButton
                                    icon={BuyTicketIcon}
                                    text={"Купить билет за"}
                                    price={totalCount}
                                    func={handleBuyJackpotTicket}
                                />
                            </div>
                        </div>

                        <div className="choose-number-block">
                            <div className="buy-ticket-block_header">
                                <div className="buy-ticket-block_header__title">Ваш счастливый номер</div>
                                <div className="buy-ticket-block_header__subtitle">
                                    Выберите номер билета.
                                </div>
                            </div>

                            <div className="choose-number-block_filter">
                                <Input
                                    className="choose-number-block_filter__search-ticket-number"
                                    placeholder="Поиск номера билета"
                                    prefix={<img src={SearchIcon} alt="icon" />}
                                    value={searchValue}
                                    onChange={handleSearchNumber}
                                />
                                <div className="choose-number-block_filter__switch">
                                    <span>Только доступные</span>
                                    <Switch
                                        checked={isChecked}
                                        onChange={onSwitchChange}
                                        className="switcher"
                                    />
                                </div>
                            </div>

                            <div className="choose-number-block_tickets">
                                {!isNotTicket ? (
                                    <>
                                        {visibleTickets.map((ticket) => {
                                            const isActive = !takenSet.has(ticket.ticket_number);

                                            return (
                                                <div
                                                    className={`choose-number-block_tickets__item ${selectedTicketId === ticket.ticket_number ? "selected" : ""
                                                        }`}
                                                    key={ticket.ticket_number}
                                                    onClick={() => {
                                                        const isActive = !takenSet.has(ticket.ticket_number);
                                                        if (!isActive) return;

                                                        handleBuyLuckyTicket(ticket.ticket_number);
                                                    }}
                                                >
                                                    {isActive ? (
                                                        <img src={TicketIcon} alt="icon" width={40} height={40} />
                                                    ) : (
                                                        <img src={TicketDisabledIcon} alt="icon" width={40} height={40} />
                                                    )}

                                                    <div
                                                        className={
                                                            isActive
                                                                ? "choose-number-block_tickets__item___number"
                                                                : "choose-number-block_tickets__item___number disabled"
                                                        }
                                                    >
                                                        {ticket.ticket_number}
                                                    </div>
                                                </div>
                                            );
                                        })}

                                    </>
                                ) : (
                                    <div className="choose-number-block_tickets__error">
                                        <span>Неверный номер, попробуйте искать до 777.</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </Modal>

                    <CompleteModal
                        infoModalOpen={infoModalOpen}
                        setInfoModalOpen={setInfoModalOpen}
                        isError={isError}
                    />
                </div>
            )}
        </>
    );
}

export default JackpotPage;
